import { gql } from '@apollo/client';

export const ALL_STAKEHOLDER_ROLES = gql`
  query AllStakeholderRoles {
    stakeholderRoles: getStakeholderRoles {
      id
      name
    }
  }
`;
